(function() {
    'use strict';

    angular
        .module('tmgApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('import-constructel', {
            parent: 'import',
            url: '/import-constructel?page&sort&search&status',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tmgApp.importConstructel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/import-constructel/import-constructel.html',
                    controller: 'ImportConstructelController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'dateCreation,desc',
                    squash: true
                },
                search: null,
                status: null,
                type: null,
                dateFrom:null,
                dateTo:null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search,
                        status: $stateParams.status,
                        type: $stateParams.type,
                        dateFrom: $stateParams.dateFrom,
                        dateTo: $stateParams.dateTo
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('importConstructel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('import-constructel-detail', {
            parent: 'import-constructel',
            url: '/import-constructel/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'tmgApp.importConstructel.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/import-constructel/import-constructel-detail.html',
                    controller: 'ImportConstructelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('importConstructel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ImportConstructel', function($stateParams, ImportConstructel) {
                    return ImportConstructel.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'import-constructel',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('import-constructel-detail.edit', {
            parent: 'import-constructel-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-dialog.html',
                    controller: 'ImportConstructelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ImportConstructel', function(ImportConstructel) {
                            return ImportConstructel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('import-constructel.new', {
            parent: 'import-constructel',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-dialog.html',
                    controller: 'ImportConstructelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                dateCreation: null,
                                nbInterventions: null,
                                csv: null,
                                csvContentType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('import-constructel', null, { reload: 'import-constructel' });
                }, function() {
                    $state.go('import-constructel');
                });
            }]
        })
        .state('import-constructel.edit', {
            parent: 'import-constructel',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-dialog.html',
                    controller: 'ImportConstructelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ImportConstructel', function(ImportConstructel) {
                            return ImportConstructel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('import-constructel', null, { reload: 'import-constructel' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('import-constructel.delete', {
            parent: 'import-constructel',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-delete-dialog.html',
                    controller: 'ImportConstructelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ImportConstructel', function(ImportConstructel) {
                            return ImportConstructel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('import-constructel', null, { reload: 'import-constructel' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('import-constructel.newConstructel', {
            parent: 'import-constructel',
            url: '/newConstructel',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/import-constructel/import-constructel-newFile-dialog.html',
                    controller: 'ImportConstructelNewDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                files: [],
                                typeImport: null,
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('import-constructel', null, { reload: 'import-constructel' });
                }, function() {
                    $state.go('import-constructel');
                });
            }]
        });



    }

})();
